import React, { useEffect } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import BaseModal from '../utils/BaseModal/BaseModal';
import { ButtonWrapper, CancelButton, Container, Form, SubmitButton } from './CreateAssetFolderModal.styles';
import Input from '../../utils/inputs/Input/Input';
import { useDispatch, useSelector } from 'react-redux';
import { notifyError, notifyInfo } from '../../../utils/notify';
import { createAssetFolders, editAssetFolder } from '../../../store/slices/assetFolder/asyncThunks';
import { selectAssetFolderActionsPending } from '../../../store/slices/assetFolder/slice';

const uploadCreateAssetFolderFormSchema = yup.object({
  name: yup.string().required('Name is required'),
});

const CreateAssetFolderModal = ({ modalRef, onSuccess, selectedFolder, setSelectedFolder, influencerId }) => {
  const dispatch = useDispatch();
  const { createAssetFolders: createAssetFoldersPending, editAssetFolder: editAssetFolderPending } = useSelector(
    selectAssetFolderActionsPending,
  );

  const {
    handleSubmit,
    formState: { errors },
    register,
    reset,
    setValue,
  } = useForm({
    delayError: 300,
    defaultValues: {
      name: '',
    },
    resolver: yupResolver(uploadCreateAssetFolderFormSchema),
  });

  useEffect(() => {
    if (selectedFolder) {
      setValue('name', selectedFolder.name);
    }
  }, [selectedFolder, setValue]);

  const onSubmit = async data => {
    let { name } = data;

    if (selectedFolder) {
      dispatch(editAssetFolder({ folderId: selectedFolder.id, name, ...(influencerId && { influencerId }) }))
        .unwrap()
        .then(() => {
          modalRef.current.hide();
          setSelectedFolder({ ...selectedFolder, name });
          notifyInfo('Folder edited successfully!');
        })
        .catch(err => {
          notifyError(err.message);
        });
    } else {
      dispatch(createAssetFolders({ name, ...(influencerId && { influencerId }) }))
        .unwrap()
        .then(() => {
          modalRef.current.hide();
          onSuccess();
          notifyInfo('Folder created successfully!');
        })
        .catch(err => {
          notifyError(err.message);
        });
    }
  };

  return (
    <BaseModal
      title={selectedFolder ? 'Edit Folder' : 'Create Folder'}
      ref={modalRef}
      onClose={() => {
        modalRef.current.hide();
      }}
      onAfterClose={() => {
        if (!selectedFolder) {
          reset();
        }
      }}>
      <Container>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Input label="Name" placeholder="Enter name" {...register('name')} error={errors.name?.message} />
          <ButtonWrapper>
            <CancelButton
              title="Cancel"
              onClick={() => {
                modalRef.current.hide();
              }}
              type="button"
            />
            <SubmitButton
              type="submit"
              title={selectedFolder ? 'Edit' : 'Save'}
              isLoading={createAssetFoldersPending || editAssetFolderPending}
            />
          </ButtonWrapper>
        </Form>
      </Container>
    </BaseModal>
  );
};

export default CreateAssetFolderModal;
